import { render } from "./NewInvoicePage.vue?vue&type=template&id=2b6cc293&scoped=true"
import script from "./NewInvoicePage.vue?vue&type=script&lang=js"
export * from "./NewInvoicePage.vue?vue&type=script&lang=js"

import "./NewInvoicePage.vue?vue&type=style&index=0&id=2b6cc293&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6cc293"]])

export default __exports__